<div class="modal-header">
	<button class="button white pull-left cancel-button">{{t "common.cancel"}}</button>
	<button class="button green pull-right save-button">{{t "common.done"}}</button>
	<h4 data-i18n="mediaLibrary.title"></h4>
</div>
<div class="modal-body"></div>
